import { GET_CITYS } from './../constants/types';

const initialState = [];
export default function(state = initialState, action) {
    switch(action.type)
    {
        case GET_CITYS: 
            return action.payload;
        default: 
            return state;
    }
}